import { getHubID } from "@hubspot/cms-components";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://91f7eea6811529c95c7b8d8843f3c0ae@o4506160724508672.ingest.us.sentry.io/4509122178908160",
  environment: getHubID() === 4047198 ? 'production' : 'test',
  integrations: [
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [
    // https://145563513.hs-sites-eu1.com/_hcms/api/
    /^https:\/\/145563513\.hs-sites-eu1\.com\/_hcms\/api/,
    // https://www.lumme-energia.fi/_hcms/api/
    /^https:\/\/www\.lumme-energia\.fi\/_hcms\/api/,
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});